import { PostCheckoutAuthSignInTrigger, TriggerHandler } from "../types";

/**
 * This is dependant upon the legacy charge api endpoint, which will be deprecated once we've
 * configured all the remaining sign up backend checkout logic to log the user in via the checkouts
 * (namely scoop, influencer and breeder checkouts)
 * It's used in storyblok
 * */
export const authSignInHandler: TriggerHandler<PostCheckoutAuthSignInTrigger> = async (
  _api,
  context,
  _trigger,
) => {
  console.log("in authSignInHandler");
  const { firstOrder } = context.sources;

  if (!firstOrder?.authData) {
    return false;
  }

  const { accessToken, refreshToken } = firstOrder.authData;

  if (accessToken && refreshToken) {
    await context.auth.forceLogin({
      access_token: accessToken,
      refresh_token: refreshToken,
      expires_in: firstOrder.authData.expiresIn,
      token_type: "Bearer",
    }, true);
    return true;
  }

  return false;
};
